import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const ReciboService = {
    fetchVentasInstaladaSeguimiento: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre, list }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/recibos/instaladasconseguimiento'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre, list },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en ReciboService.fetchVentas:', error);
            throw error;
        }
    },
    createSeguimientoPago: async ({ token, formData }) => {
        try {
            const response = await axios.post(buildApiUrl('/api/recibos/createSeguimientoPago'), formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReciboService.createSeguimientoPago:', error);
            throw error;
        }
    },
    exportarVentasInstaladasSeguimientoExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/recibos/exportarVentasInstaladasconseguimiento'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ReciboService.exportarVentasInstaladasExcel:', error);
            throw error;
        }
    },
    getStatisticsInstaladas: async ({ token, fechaInicio, fechaFin }) => {
        try {
            const url = buildApiUrl(`/api/recibos/countinstalada`);

            const response = await axios.post(url, {
                fechaInicio: fechaInicio || null,
                fechaFin: fechaFin || null
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en ReciboService.getStatisticsInstaladas:', error);
            throw error;
        }
    },
    getRecibos: async ({ token, vid }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/recibos/'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { vid },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReciboService.getRecibos:', error);
            throw error;
        }
    },
    getSeguimientoPagos: async ({ token, vid }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/recibos/seguimientoPagos'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { vid },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReciboService.getSeguimientoPagos:', error);
            throw error;
        }
    },
};